module.exports = __webpack_public_path__ + "assets/img/Capa2048.67583d71.png";